import { observer } from 'mobx-react';
import { FC, ReactElement, memo, useMemo } from 'react';
import { mealItemEditModalStore } from '../../store/mealItemEditModalStore';
import integrationsStore from '~/mobx/integrationStore';
import { localeStore } from '~/mobx/localesStore';
import { isDisabledByPos } from '~/utils/helpers';
import { TOOLTIP_DURATION, TOOLTIP_POSITION } from '~/view/components/Controls/CustomTooltip/CustomTooltip';
import Switcher from '~/view/components/Controls/Switcher/Switcer';
import IntegrationManager from '~/view/components/IntegrationManager/IntegrationManager';
import Text from '~/view/components/Text/Text';
import TooltipIcon from '~/view/components/TooltipIcon/TooltipIcon';

export const MealItemEditModalFormDefaultSwitcher: FC = memo(
  observer((): ReactElement => {
    const { comboMealChangeItemInItemChoice } = integrationsStore.posRestrictions || {};

    const disabled = useMemo((): boolean => {
      return !mealItemEditModalStore.item && !isDisabledByPos(comboMealChangeItemInItemChoice);
    }, [mealItemEditModalStore.item, comboMealChangeItemInItemChoice]);

    return (
      <div className="d-flex flex-row align-items-center mt-6">
        <IntegrationManager setting={comboMealChangeItemInItemChoice} tooltipOptions={{ position: TOOLTIP_POSITION.PORTAL }} withTooltip>
          <div className="d-flex flex-row align-items-center">
            <Switcher status={mealItemEditModalStore.item?.is_default || 0} onChange={mealItemEditModalStore.onChangeDefault} disabled={disabled} />
            <Text type="switcher-label" text="default_cmgci" disabled={disabled} />
          </div>
        </IntegrationManager>

        <TooltipIcon
          duration={TOOLTIP_DURATION.EXTRA_LARGE}
          position={TOOLTIP_POSITION.PORTAL}
          message={localeStore.t('hint_default_cmgci')}
          wrapperClassName="ml-3"
        />
      </div>
    );
  })
);
